var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "si:unlock-fill"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 5.83333C5.83193 4.81819 6.20118 3.83745 6.87173 3.0753C7.54229 2.31315 8.46801 1.82201 9.47507 1.69412C10.4821 1.56623 11.5012 1.81038 12.341 2.38074C13.1808 2.95109 13.7834 3.8084 14.0358 4.79167C14.0911 5.00572 14.059 5.23295 13.9468 5.42338C13.8345 5.61381 13.6511 5.75183 13.4371 5.80708C13.223 5.86234 12.9958 5.8303 12.8054 5.71801C12.6149 5.60572 12.4769 5.42239 12.4217 5.20833C12.2704 4.61822 11.9088 4.10366 11.4049 3.76131C10.901 3.41897 10.2894 3.2724 9.68505 3.34915C9.0807 3.42589 8.52518 3.72067 8.12283 4.1781C7.72048 4.63553 7.499 5.22413 7.5 5.83333V8.33333H14.5C15.2333 8.33333 15.8333 8.93333 15.8333 9.66667V15.5C15.8333 16.6 14.9333 17.5 13.8333 17.5H6.16667C5.06667 17.5 4.16667 16.6 4.16667 15.5V9.66667C4.16667 8.93333 4.76667 8.33333 5.5 8.33333H5.83333V5.83333ZM10 10.2083C9.66862 10.208 9.347 10.3205 9.08811 10.5274C8.82923 10.7343 8.64852 11.0231 8.57575 11.3464C8.50298 11.6697 8.54248 12.0082 8.68776 12.306C8.83304 12.6038 9.07543 12.8433 9.375 12.985V15C9.375 15.1658 9.44085 15.3247 9.55806 15.4419C9.67527 15.5592 9.83424 15.625 10 15.625C10.1658 15.625 10.3247 15.5592 10.4419 15.4419C10.5592 15.3247 10.625 15.1658 10.625 15V12.985C10.9246 12.8433 11.167 12.6038 11.3122 12.306C11.4575 12.0082 11.497 11.6697 11.4243 11.3464C11.3515 11.0231 11.1708 10.7343 10.9119 10.5274C10.653 10.3205 10.3314 10.208 10 10.2083Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon-unlock.67ed6df9144c84d60124ab87137c098b.svg";
export { ForwardRef as ReactComponent };